/* ============================================================
   BBF Cart Drawer — open/close, qty update, remove, refresh
   ============================================================ */
(function () {

  var drawer  = document.getElementById('bbf-cart-drawer');
  var overlay = document.getElementById('bbf-cart-overlay');
  var closeBtn = document.getElementById('bbf-cart-close');
  var cartIcon = document.getElementById('cart-icon-bubble');

  if (!drawer) return;

  /* ---- Open / Close ----
     This store uses an external cart-drawer app, so the theme's own drawer is
     DISABLED: openCart is a no-op and the cart icon is left alone so the app
     (or the default /cart link) handles it. Add-to-cart still works — the app
     opens on the /cart/add.js request. Everything else (count refresh, qty,
     remove) stays intact but never becomes visible. */
  function openCart() {
    /* disabled — external cart app handles the drawer */
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  /* Cart icon: no interception — let the external app / default link handle it */

  if (closeBtn)  closeBtn.addEventListener('click', closeCart);
  if (overlay)   overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---- Refresh cart via section rendering API ---- */
  function refreshCart() {
    var body = document.getElementById('bbf-cart-body');
    if (body) body.classList.add('is-loading');

    fetch('/?sections=bbf-cart-drawer', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data['bbf-cart-drawer']) return;

      /* Parse the returned HTML and replace relevant nodes */
      var parser = new DOMParser();
      var doc = parser.parseFromString(data['bbf-cart-drawer'], 'text/html');

      /* Replace drawer inner content */
      var newDrawer = doc.getElementById('bbf-cart-drawer');
      if (newDrawer && drawer) {
        drawer.innerHTML = newDrawer.innerHTML;
        /* Re-bind inner close button */
        var newClose = drawer.querySelector('#bbf-cart-close');
        if (newClose) newClose.addEventListener('click', closeCart);
      }

      /* Update cart count bubbles */
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.bbf-cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        });
    })
    .catch(function (err) {
      console.warn('BBF cart refresh error:', err);
      if (body) body.classList.remove('is-loading');
    });
  }

  /* ---- Change quantity ---- */
  function changeQty(line, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () { refreshCart(); })
    .catch(function (err) { console.warn('BBF qty change error:', err); });
  }

  /* ---- Event delegation inside drawer ---- */
  drawer.addEventListener('click', function (e) {

    /* Qty buttons */
    var qtyBtn = e.target.closest('.bbf-cart-item__qty-btn');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.dataset.line, 10);
      var qty  = parseInt(qtyBtn.dataset.qty, 10);
      changeQty(line, qty);
      return;
    }

    /* Remove button */
    var removeBtn = e.target.closest('.bbf-cart-item__remove');
    if (removeBtn) {
      var line = parseInt(removeBtn.dataset.line, 10);
      changeQty(line, 0);
      return;
    }
  });

  /* ---- Listen for ATC success from product section ---- */
  document.addEventListener('bbf:cart:updated', function () {
    refreshCart();
    openCart();
  });

})();
